import { UserInterface } from './../../models/interfaces/user.interface';
import { type } from '../utils/util';

export class UserActions {
    static ADD_USERS = type('ADD_USERS');
    static ADD_USER = type('ADD_USER');
    static EDIT_USER = type('EDIT_USER');
    static REMOVE_USER = type('REMOVE_USER');

    addUsers(payload: { users: UserInterface[] }) {
        return {
            type: UserActions.ADD_USERS,
            payload: payload
        };
    }

    addUser(payload: { user: UserInterface }) {
        return {
            type: UserActions.ADD_USER,
            payload: payload
        };
    }

    editUser(payload: { user: UserInterface, id: number }) {
        return {
            type: UserActions.EDIT_USER,
            payload: payload
        };
    }

    removeUser(payload: { id: number }) {
        return {
            type: UserActions.REMOVE_USER,
            payload: payload
        }
    }

}



// WEBPACK FOOTER //
// ./src/states/user/user.actions.ts